<div *ngIf="isLoading" class="overlay">
    <div class="spinner"></div>
  </div>
  <div class="container-fluid py-4">
    <div class="row mb-4">
      <!-- <div class="col-md-4" *ngFor="let card of resumenCards">
                  <div class="card card-stats">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-5">
                          <div
                            class="icon-big text-center text-black rounded shadow"
                            [ngClass]="card.bgClass"
                          >
                            <i [class]="card.icon"></i>
                          </div>
                        </div>
                        <div class="col-7 d-flex flex-column justify-content-center">
                          <p class="card-category mb-0">{{ card.label }}</p>
                          <h4 class="card-title mb-0 text-white">{{ card.value }}</h4>
                        </div>
                      </div>
                    </div>
                    <div class="card-footer">
                      <div class="stats">
                        <small class="desc">{{ card.desc }}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
      <div class="card">
        <div class="card-header">
          <div class="card-tools">
            <a
              [routerLink]="['/numbers/accounting/quickbooks/vendors/add']"
              class="btn btn-dark btn-sm btn-new"
            >
              New vendor
            </a>
          </div>
        </div>
        <div class="card-body" *ngIf="step == 1">
          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead class="thead">
                <tr>
                  <th><strong>Employee</strong></th>
                  <th><strong>Active</strong></th>
                  <th><strong>Actions</strong></th>
                </tr>
              </thead>
  
              <tbody>
                <tr *ngFor="let item of data">
                  <td>{{ item?.DisplayName }}</td>
                  <td>
                    <span
                      class="badge span__badge"
                      [ngClass]="item?.Active ? 'badge-success' : 'badge-danger'"
                    >
                      {{ item?.Active ? "Active" : "Inactive" }}
                    </span>
                  </td>
                  <td class="text-center">
                    <a
                      [routerLink]="[
                        '/numbers/accounting/quickbooks/vendors/edit',
                        item.Id,
                        item.SyncToken
                      ]"
                      class="btn btn-link text-dark btn-sm p-2 btn-del"
                    >
                      <i class="fas fa-edit"></i>
                    </a>
                    <button
                      (click)="deleteData(item.Id, item.SyncToken)"
                      class="btn btn-link text-dark btn-sm p-2 btn-del"
                    >
                      <i class="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  